import { Outlet } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import { AppContexts } from "@/app/AppContexts";

export const RootLayout = () => {
  return (
    <AppContexts withSidebar={false}>
      <ScrollToTop />
      <Outlet />
    </AppContexts>
  );
};
